import {useTranslation} from '@aboutyou/i18n';
import {assertUnreachable} from '@aboutyou/utils';
import React, {useMemo} from 'react';
import {PersonalisedBadge} from '../types';
import {Badge, BadgeProps} from './GenericBadges';

export const PersonalizedBadge: React.FC<
  Omit<BadgeProps, 'text'> & {
    type: PersonalisedBadge;
  }
> = ({type, ...badgeProps}) => {
  const {t} = useTranslation();

  const badge = useMemo(() => {
    switch (type) {
      case 'favorite':
        return {
          text: t('Favourite brands'),
          emoji: '❤️',
        };
      case 'oftenBought':
        return {
          text: t('Frequently purchased'),
          emoji: '🔥',
        };
      case 'recommended':
        return {
          text: t('Our recommendation'),
          emoji: '👌',
        };
      default:
        assertUnreachable(type);
    }
  }, [type, t]);

  return <Badge {...badgeProps} text={badge.text} emoji={badge.emoji} />;
};
